exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loading-wrapper {\n  text-align: center;\n  padding-top: 100px;\n  min-height: 320px;\n  width: 100%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/terms-and-conditions/terms-and-conditions.component.scss
// module id = 956
// module chunks = 22